// FAQ page: accordion (multiple questions can stay open at once) + client-side
// search filter — everything runs against data already in the DOM.
//
// No page copy lives in this file (per the brief): the "no results" message
// is a hidden element in the page's own markup (toggled via a class), and
// every filterable question already carries its own lowercased, tag-stripped
// searchable text in a `data-faq-search` attribute — the JS never builds or
// injects user-facing strings, only reads that attribute and toggles classes.
$(function () {
    const $root = $('[data-faq-root]');

    if (!$root.length) {
        return;
    }

    const MIN_QUERY_LENGTH = 3;

    // Accordion: toggling one question never affects the others.
    $root.on('click', '[data-faq-toggle]', function () {
        $(this).closest('[data-faq-question]').toggleClass('is-open');
    });

    // Search: filters the visible questions, hides blocks (and their
    // matching anchor pill) with zero remaining matches.
    const $input = $root.find('[data-faq-input]');
    const $questions = $root.find('[data-faq-question]');
    const $blocks = $root.find('[data-faq-block]');
    const $pills = $root.find('[data-faq-pill]');
    const $empty = $root.find('[data-faq-empty]');

    const applyFilter = (rawQuery) => {
        const query = rawQuery.trim().toLowerCase();
        const isFiltering = query.length >= MIN_QUERY_LENGTH;

        let anyBlockVisible = false;

        $blocks.each(function () {
            const $block = $(this);
            const blockId = $block.data('faqBlock');
            const $blockQuestions = $block.find('[data-faq-question]');
            let blockHasMatch = false;

            $blockQuestions.each(function () {
                const $question = $(this);
                const matches = !isFiltering || $question.data('faqSearch').includes(query);
                $question.toggleClass('is-hidden', !matches);
                blockHasMatch = blockHasMatch || matches;
            });

            $block.toggleClass('is-hidden', !blockHasMatch);
            $pills.filter(`[data-faq-pill="${blockId}"]`).toggleClass('is-hidden', !blockHasMatch);
            anyBlockVisible = anyBlockVisible || blockHasMatch;
        });

        $empty.toggleClass('is-hidden', anyBlockVisible);
    };

    $input.on('input', function () {
        applyFilter(this.value);
    });
});
